module.exports = __webpack_public_path__ + "static/oil-f9f95ee686b2b72febbf0bc76ab3a52a.webp";